import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {getPortfolios, getServices} from "../../../utils/cms.utils";

const SHOW_PORTFOLIO_ITEM = 6;

const ThreeColumns = () => {
    const [portfolioData, setPortfolioData] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [next, setNext] = useState(SHOW_PORTFOLIO_ITEM);
    const [hoverIndex, setHoverIndex] = useState(null);
    const [hoverImageIndex, setHoverImageIndex] = useState({});
    const hoverTimeoutRef = useRef(null);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            try {
                setLoading(true);
                const [portfolioRes, servicesRes] = await Promise.all([getPortfolios(), getServices(),]);
                const portfolios = Array.isArray(portfolioRes) ? portfolioRes : [];
                const servicesData = Array.isArray(servicesRes) ? servicesRes : [];

                if (mounted) {
                    setPortfolioData(
                        [...portfolios].sort((a, b) => (b.no ?? 0) - (a.no ?? 0))
                    );

                    setServices(
                        [...servicesData].sort(
                            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
                        )
                    );
                }
            } catch (err) {
                if (mounted) {
                    setPortfolioData([]);
                    setServices([]);
                }
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchData();

        return () => {
            mounted = false;
        };
    }, []);

    /* ===== HANDLERS ===== */

    const handleLoadData = () =>
        setNext((prev) => prev + SHOW_PORTFOLIO_ITEM);

    const handleMouseEnter = (index, images) => {
        hoverTimeoutRef.current = setTimeout(() => {
            if (images?.length > 1) {
                setHoverImageIndex((prev) => ({
                    ...prev,
                    [index]: Math.floor(Math.random() * images.length),
                }));
                setHoverIndex(index);
            }
        }, 800);
    };

    const handleMouseLeave = () => {
        clearTimeout(hoverTimeoutRef.current);
        setHoverIndex(null);
    };

    /* ===== FILTER LOGIC (CMS-BASED) ===== */
    const filteredData = portfolioData.filter((item) => {
        const matchSearch = item.title
            ?.toLowerCase()
            .includes(search.toLowerCase());

        const matchFilter =
            filter === "all" ||
            item.tags?.includes(filter);

        return matchSearch && matchFilter;
    });


    if (loading) return null;

    return (
        <section className="portfolio">

            {/* INTRO */}
            <div className="portfolio__intro">
                <span className="portfolio__tag">Our Projects & Portfolio</span>
                <h2>Discover Our Builds</h2>
                <h4>Delivering Reliable Engineering Solutions</h4>

                <p className="portfolio__desc--secondary">
                    Kami melaksanakan proyek sipil dan engineering dengan fokus pada
                    kualitas, keselamatan, dan efisiensi.
                </p>
            </div>

            {/* FILTER */}
            <div className="portfolio__filters">
                <button
                    className={`portfolio__filter ${
                        filter === "all" ? "is-active" : ""
                    }`}
                    onClick={() => setFilter("all")}
                >
                    All
                </button>

                {services.map((service) => (
                    <button
                        key={service.id}
                        className={`portfolio__filter ${
                            filter === service.id ? "is-active" : ""
                        }`}
                        onClick={() => setFilter(service.id)}
                    >
                        {service.titleEn}
                    </button>
                ))}
            </div>

            {/* SEARCH */}
            <div className="portfolio__search">
                <i className="flaticon-search"/>
                <input
                    type="text"
                    placeholder="Search project"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <div className="portfolio__divider"/>

            {/* GRID */}
            <div className="container">
                <div className="row">
                    {filteredData.slice(0, next).map((data, index) => (
                        <div className="col-lg-4 col-md-6 mt-25" key={data.id}>
                            <div
                                className="portfolio-card"
                                onMouseEnter={() =>
                                    handleMouseEnter(index, data.images)
                                }
                                onMouseLeave={handleMouseLeave}
                            >
                                <Link
                                    to={`/portfolio/${data.id}`}
                                    className="portfolio-card__link"
                                />

                                <img
                                    src={
                                        hoverIndex === index &&
                                        hoverImageIndex[index] !== undefined
                                            ? data.images?.[
                                                hoverImageIndex[index]
                                                ]
                                            : data.images?.[0]
                                    }
                                    alt={data.title}
                                />

                                <div className="portfolio-card__overlay"/>

                                <div className="portfolio-card__content">
                                    <h5>{data.title}</h5>
                                    <span>{data.caption}</span>
                                </div>

                                <div className="portfolio-card__icon">
                                    <i className="flaticon-right-up"/>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {next < filteredData.length && (
                    <div className="text-center mt-70">
                        <button
                            onClick={handleLoadData}
                            className="build_button"
                        >
                            Load More <i className="flaticon-right-up"/>
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ThreeColumns;
